import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { Car, LogIn } from 'lucide-react';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success('Erfolgreich angemeldet');
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      const msg = err.response?.data?.detail || 'Anmeldung fehlgeschlagen';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="admin-login-page">
      <Card className="w-full max-w-md shadow-lg border-0 rounded-sm">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="w-12 h-12 bg-[#0E518D] rounded-sm flex items-center justify-center">
              <Car className="w-6 h-6 text-white" strokeWidth={1.5} />
            </div>
          </div>
          <CardTitle className="font-heading text-2xl text-slate-900">Admin Login</CardTitle>
          <p className="text-sm text-slate-500 font-body mt-1">GB Sylt Mietwagen</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username" className="font-body text-sm">Benutzername</Label>
              <Input
                id="username"
                data-testid="login-username-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                className="mt-1 rounded-sm"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="font-body text-sm">Passwort</Label>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwort eingeben"
                className="mt-1 rounded-sm"
                required
              />
            </div>
            <Button
              type="submit"
              data-testid="login-submit-button"
              className="w-full bg-[#0E518D] hover:bg-[#0B4171] text-white rounded-sm py-3 font-body font-medium"
              disabled={loading}
            >
              {loading ? (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
              ) : (
                <>
                  <LogIn className="w-4 h-4 mr-2" /> Anmelden
                </>
              )}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <Link
              to="/admin/forgot-password"
              className="text-sm text-[#0E518D] hover:underline font-body"
              data-testid="forgot-password-link"
            >
              Passwort vergessen?
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
